import React from 'react'
import { useState } from 'react';
import {
  CategoryCard,
  Title,
  WelLink,
  ImageContainer
} from './ShopByCategoryCardStyle.style'
const ShopByCategoryCard = ({
  image,
  title,
  webLink,
  priority
}) => {

  const title2 = title.split(' ').pop()

  return (
    <WelLink href={webLink}>
    <CategoryCard>
      <Title>
        <span>{title.replace(title2, '')}</span>
        <span className='boldDark'>{title2}</span>
      </Title>
      <ImageContainer>
        <img 
          src={image} 
          alt={title || 'Category'} 
          fetchpriority={priority ? "high" : "auto"}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          width="300"
          height="300"
        />  
      </ImageContainer>
      
    </CategoryCard>
    </WelLink>
  )
}

export default ShopByCategoryCard